<input matInput style="display: none" [matDatepicker]="picker"
  [min]="dateMin"
  [max]="dateMax"
  [(ngModel)]="value">
  <mat-datepicker-toggle matSuffix [for]="picker" id="date" [disabled]="disabled"></mat-datepicker-toggle>
  <mat-datepicker #picker [startView]="'multi-year'" [touchUi]="true" (monthSelected)="monthSelected($event); picker.close();"></mat-datepicker>

  @if (value) {
    <label for="date" class="dataDisplay pointer" [class.invalid]="!valid" (click)="openPicker()">
      <button mat-stroked-button [disabled]="disabled">{{value| date :'MM - yyyy'}}</button>
    </label>
  }

  @if (!value) {
    <label for="date" class="dataDisplay"  (click)="openPicker()">
      <button mat-stroked-button [disabled]="disabled" color="{{valid?'':'danger'}}">{{'general.selectionnerDate'|translate}}</button>
    </label>
  }
